module.exports = __webpack_public_path__ + "img/shop_icon.ebd70b22.svg";